import Locales from './locales'
import brandedColors from './webchat-branding'

const getConfig = (isLogged, user) => {
  const translations = Locales.getTranslations()

  return {
    accountSid: process.env.REACT_APP_ACCOUNT_SID,
    flexFlowSid: process.env.REACT_APP_FLEX_FLOW_SID,
    colorTheme: {
      overrides: brandedColors
    },
    fileAttachment: {
      enabled: false
    },
    startEngagementOnInit: false,
    context: {
      friendlyName: user?.phone
    },
    preEngagementConfig: {
      description: translations['form.description'],
      fields: [
        {
          label: translations['fields.name'],
          type: 'InputItem',
          attributes: {
            name: 'name',
            type: 'text',
            required: true,
            value: '',
            readOnly: false
          }
        },
        {
          label: translations['fields.lastName'],
          type: 'InputItem',
          attributes: {
            name: 'lastName',
            type: 'text',
            required: true,
            value: '',
            readOnly: false
          }
        },
        {
          label: translations['fields.email'],
          type: 'InputItem',
          attributes: {
            name: 'email',
            type: 'email',
            required: true,
            value: '',
            readOnly: false
          }
        },
        {
          label: translations['fields.phone'],
          type: 'PhoneItem',
          attributes: {
            name: 'phoneNumber',
            type: 'text',
            required: true,
            value: '',
            readOnly: false
          }
        }
      ],
      submitLabel: translations['form.submitLabel']
    }
  }
}

export default getConfig
